/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConnectionsRouteImport } from './routes/connections'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EventsRouteImport } from './routes/events'
import { Route as GovernanceRouteImport } from './routes/governance'
import { Route as NotesRouteImport } from './routes/notes'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ConnectCodeRouteImport } from './routes/connect.$code'
import { Route as ESlugRouteImport } from './routes/e/$slug'
import { Route as NotificationsNotificationIdRouteImport } from './routes/notifications/$notificationId'
import { Route as AdminEventEventIdRouteImport } from './routes/admin/event/$eventId'
import { Route as ESlugFeedbackFormIdRouteImport } from './routes/e/$slug_.feedback.$formId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectionsRoute = ConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const GovernanceRoute = GovernanceRouteImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => rootRouteImport,
} as any)
const NotesRoute = NotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectCodeRoute = ConnectCodeRouteImport.update({
  id: '/connect/$code',
  path: '/connect/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const ESlugRoute = ESlugRouteImport.update({
  id: '/e/$slug',
  path: '/e/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsNotificationIdRoute =
  NotificationsNotificationIdRouteImport.update({
    id: '/notifications/$notificationId',
    path: '/notifications/$notificationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminEventEventIdRoute = AdminEventEventIdRouteImport.update({
  id: '/admin/event/$eventId',
  path: '/admin/event/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const ESlugFeedbackFormIdRoute = ESlugFeedbackFormIdRouteImport.update({
  id: '/e/$slug_/feedback/$formId',
  path: '/e/$slug/feedback/$formId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/connections': typeof ConnectionsRoute
  '/dashboard': typeof DashboardRoute
  '/events': typeof EventsRoute
  '/governance': typeof GovernanceRoute
  '/notes': typeof NotesRoute
  '/profile': typeof ProfileRoute
  '/sign-in': typeof SignInRoute
  '/connect/$code': typeof ConnectCodeRoute
  '/e/$slug': typeof ESlugRoute
  '/notifications/$notificationId': typeof NotificationsNotificationIdRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/event/$eventId': typeof AdminEventEventIdRoute
  '/e/$slug/feedback/$formId': typeof ESlugFeedbackFormIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/connections': typeof ConnectionsRoute
  '/dashboard': typeof DashboardRoute
  '/events': typeof EventsRoute
  '/governance': typeof GovernanceRoute
  '/notes': typeof NotesRoute
  '/profile': typeof ProfileRoute
  '/sign-in': typeof SignInRoute
  '/connect/$code': typeof ConnectCodeRoute
  '/e/$slug': typeof ESlugRoute
  '/notifications/$notificationId': typeof NotificationsNotificationIdRoute
  '/admin': typeof AdminIndexRoute
  '/admin/event/$eventId': typeof AdminEventEventIdRoute
  '/e/$slug/feedback/$formId': typeof ESlugFeedbackFormIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/connections': typeof ConnectionsRoute
  '/dashboard': typeof DashboardRoute
  '/events': typeof EventsRoute
  '/governance': typeof GovernanceRoute
  '/notes': typeof NotesRoute
  '/profile': typeof ProfileRoute
  '/sign-in': typeof SignInRoute
  '/connect/$code': typeof ConnectCodeRoute
  '/e/$slug': typeof ESlugRoute
  '/notifications/$notificationId': typeof NotificationsNotificationIdRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/event/$eventId': typeof AdminEventEventIdRoute
  '/e/$slug_/feedback/$formId': typeof ESlugFeedbackFormIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connections'
    | '/dashboard'
    | '/events'
    | '/governance'
    | '/notes'
    | '/profile'
    | '/sign-in'
    | '/connect/$code'
    | '/e/$slug'
    | '/notifications/$notificationId'
    | '/admin/'
    | '/admin/event/$eventId'
    | '/e/$slug/feedback/$formId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connections'
    | '/dashboard'
    | '/events'
    | '/governance'
    | '/notes'
    | '/profile'
    | '/sign-in'
    | '/connect/$code'
    | '/e/$slug'
    | '/notifications/$notificationId'
    | '/admin'
    | '/admin/event/$eventId'
    | '/e/$slug/feedback/$formId'
  id:
    | '__root__'
    | '/'
    | '/connections'
    | '/dashboard'
    | '/events'
    | '/governance'
    | '/notes'
    | '/profile'
    | '/sign-in'
    | '/connect/$code'
    | '/e/$slug'
    | '/notifications/$notificationId'
    | '/admin/'
    | '/admin/event/$eventId'
    | '/e/$slug_/feedback/$formId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConnectionsRoute: typeof ConnectionsRoute
  DashboardRoute: typeof DashboardRoute
  EventsRoute: typeof EventsRoute
  GovernanceRoute: typeof GovernanceRoute
  NotesRoute: typeof NotesRoute
  ProfileRoute: typeof ProfileRoute
  SignInRoute: typeof SignInRoute
  ConnectCodeRoute: typeof ConnectCodeRoute
  ESlugRoute: typeof ESlugRoute
  NotificationsNotificationIdRoute: typeof NotificationsNotificationIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminEventEventIdRoute: typeof AdminEventEventIdRoute
  ESlugFeedbackFormIdRoute: typeof ESlugFeedbackFormIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connections': {
      id: '/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof ConnectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/governance': {
      id: '/governance'
      path: '/governance'
      fullPath: '/governance'
      preLoaderRoute: typeof GovernanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notes': {
      id: '/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof NotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/$code': {
      id: '/connect/$code'
      path: '/connect/$code'
      fullPath: '/connect/$code'
      preLoaderRoute: typeof ConnectCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e/$slug': {
      id: '/e/$slug'
      path: '/e/$slug'
      fullPath: '/e/$slug'
      preLoaderRoute: typeof ESlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/$notificationId': {
      id: '/notifications/$notificationId'
      path: '/notifications/$notificationId'
      fullPath: '/notifications/$notificationId'
      preLoaderRoute: typeof NotificationsNotificationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/event/$eventId': {
      id: '/admin/event/$eventId'
      path: '/admin/event/$eventId'
      fullPath: '/admin/event/$eventId'
      preLoaderRoute: typeof AdminEventEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/e/$slug_/feedback/$formId': {
      id: '/e/$slug_/feedback/$formId'
      path: '/e/$slug/feedback/$formId'
      fullPath: '/e/$slug/feedback/$formId'
      preLoaderRoute: typeof ESlugFeedbackFormIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConnectionsRoute: ConnectionsRoute,
  DashboardRoute: DashboardRoute,
  EventsRoute: EventsRoute,
  GovernanceRoute: GovernanceRoute,
  NotesRoute: NotesRoute,
  ProfileRoute: ProfileRoute,
  SignInRoute: SignInRoute,
  ConnectCodeRoute: ConnectCodeRoute,
  ESlugRoute: ESlugRoute,
  NotificationsNotificationIdRoute: NotificationsNotificationIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminEventEventIdRoute: AdminEventEventIdRoute,
  ESlugFeedbackFormIdRoute: ESlugFeedbackFormIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
